/**
 * NIDA Attachments Rest-Api
 * API Beschreibung für die NIDA Tabellen.
 *
 * The version of the OpenAPI document: 1.0.1
 * Contact: info@meddv.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent, HttpParameterCodec } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Configuration } from '@nida-web/api/generic-interfaces/config';

@Injectable({
  providedIn: 'root',
})
export class AttachementsExternalService {
  private static ALLOWED_URLS: string[] = ['https://s3tna.meddv.de'];

  protected basePath = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(protected httpClient: HttpClient) {
    this.basePath = '';
  }

  public getPdfByURL(
    url: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/pdf' | 'application/json' | 'text/plain' }
  ): Observable<Blob>;
  public getPdfByURL(
    url: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/pdf' | 'application/json' | 'text/plain' }
  ): Observable<HttpResponse<Blob>>;
  public getPdfByURL(
    url: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/pdf' | 'application/json' | 'text/plain' }
  ): Observable<HttpEvent<Blob>>;
  public getPdfByURL(
    url: string,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/pdf' | 'application/json' | 'text/plain' }
  ): Observable<any> {
    if (url === null || url === undefined) {
      throw new Error('Required parameter url was null or undefined when calling getPdfByURL.');
    }

    let urlValid = false;
    AttachementsExternalService.ALLOWED_URLS.forEach((allowedURL) => {
      if (url.startsWith(allowedURL)) urlValid = true;
    });

    if (!urlValid) {
      throw new Error('Required parameter url is NOT ALLOWED BY INTERNAL WHITELIST.');
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/pdf', 'application/json', 'text/plain'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    headers = headers.set('x-meddv-external', 'IGNORE AUTH TOKEN');

    return this.httpClient.get(url, {
      responseType: 'blob',
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
